/**
 * 
 */
class BlockPopin {

	/**
	 * 
	 * @param {HTMLElement} element 
	 * @param {Object} args 
	 */
	constructor( element, args = {} )
	{
		const {
			id = null,
			isDisplayed = false,
		} = args;

		this.element = element;
		this.id = id;
		this.isDisplayed = isDisplayed;
		this.args = args;

		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		if ( null === this.id )
		{
			this.id = this.element.getAttribute( 'id' );
		}

		this.element.wmuBlockPopin = this;

		/**
		 * Init display status
		 */
		if ( true === this.isDisplayed )
		{
			this.show();
		}
		else
		{
			this.hide();
		}

		/**
		 * Activate close inner elements
		 */
		this.onCloseClick = this.onCloseClick.bind( this );

		this.element.querySelectorAll( '.popin-close' ).forEach( ( closeElement ) =>
		{
			closeElement.addEventListener( 'click', this.onCloseClick );
		} );
	}

	/**
	 * 
	 */
	clear()
	{
		this.element.wmuBlockPopin = undefined;
	}

	/**
	 * 
	 */
	hide()
	{
		this.isDisplayed = false;
		this.element.classList.remove( 'is-displayed' );
	}

	/**
	 * 
	 */
	show()
	{
		this.isDisplayed = true;
		this.element.classList.add( 'is-displayed' );
	}

	/**
	 * 
	 */
	toggleDisplay()
	{
		if ( true === this.isDisplayed )
		{
			this.hide();
		}
		else
		{
			this.show();
		}
	}

	/**
	 * 
	 * @param {HTMLElement} element 
	 * @param {Object} args
	 */
	setPositionFromElement( element, args = {} )
	{
		const settings = { h: 'center', v: 'center', ...args };
		const popinRect = this.element.getBoundingClientRect();
		const targetRect = element.getBoundingClientRect();
		let top, left;

		switch ( settings.h )
		{
			default:
			case 'center':
				left = targetRect.left + ( targetRect.width / 2 ) - ( popinRect.width / 2 );
				break;
			
			case 'right':
				left = targetRect.left + targetRect.width;
				break;
		}

		switch ( settings.v )
		{
			default:
			case 'center':
				top = Math.max( targetRect.top + window.scrollY - ( popinRect.height / 2 ), window.scrollY );
				break;
		}

		this.element.style.position = 'absolute';
		this.element.style.left = `${left}px`;
		this.element.style.top = `${top}px`;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onCloseClick( event )
	{
		event.preventDefault();
		this.hide();
		return false;
	}

}

export default BlockPopin;